// src/door/utils/camera.ts
let cachedStream: MediaStream | null = null;
let killer: number | null = null;

/** Получить (или создать) общий поток камеры */
export async function getCameraStream(constraints?: MediaTrackConstraints): Promise<MediaStream> {
    if (cachedStream) return cachedStream;

    const stream = await navigator.mediaDevices.getUserMedia({
        video: constraints ?? { facingMode: { ideal: "environment" } },
        audio: false,
    });

    cachedStream = stream;
    return stream;
}

/** Мягко поддержать поток «в живых» N миллисекунд (для быстрых переходов к следующему скану) */
export function keepAlive(ms = 12000) {
    if (killer != null) {
        clearTimeout(killer);
        killer = null;
    }
    killer = window.setTimeout(() => {
        stopCamera();
    }, ms);
}

/** Полностью остановить камеру немедленно */
export function stopCamera() {
    if (killer != null) {
        clearTimeout(killer);
        killer = null;
    }
    if (cachedStream) {
        try { cachedStream.getTracks().forEach(t => t.stop()); } catch {}
        cachedStream = null;
    }
}

/** Текущий поток, если есть (без запуска) */
export function peekCamera(): MediaStream | null {
    return cachedStream;
}